import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = {
  style: {
    "margin": "0 15px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_radio = _resolveComponent("el-radio");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_header = _resolveComponent("el-header");
  const _component_vipmenu = _resolveComponent("vipmenu");
  const _component_el_aside = _resolveComponent("el-aside");
  const _component_viptabs = _resolveComponent("viptabs");
  const _component_router_view = _resolveComponent("router-view");
  const _component_el_main = _resolveComponent("el-main");
  const _component_el_container = _resolveComponent("el-container");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, null, {
    default: _withCtx(() => [_createVNode(_component_el_header, {
      style: {
        "background-color": "yellow"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_row, {
        gutter: 20
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 9,
          offset: 1,
          class: "col-btn"
        }, {
          default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_radio_group, {
            style: {
              "color": "azure"
            },
            modelValue: _ctx.ttype,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.ttype = $event),
            size: "small"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.viptype, item => {
              return _openBlock(), _createBlock(_component_el_radio, {
                label: item.type,
                key: item.type
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item.type), 1)]),
                _: 2
              }, 1032, ["label"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 3
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createElementVNode("h2", {
            style: {
              "color": "red"
            }
          }, "VIP管理系统", -1)]))]),
          _: 1
        }), _createVNode(_component_el_col, {
          align: "right",
          span: 10,
          class: "col-btn"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            text: "",
            onClick: _ctx.gotoweb
          }, {
            default: _withCtx(() => [_createTextVNode("退出  " + _toDisplayString(_ctx.$store.state.name), 1)]),
            _: 1
          }, 8, ["onClick"])]),
          _: 1
        })]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_container, null, {
      default: _withCtx(() => [_createVNode(_component_el_aside, {
        width: "200px"
      }, {
        default: _withCtx(() => [_createVNode(_component_vipmenu, {
          ttype: _ctx.ttype,
          "onUpdate:ttype": _cache[1] || (_cache[1] = $event => _ctx.ttype = $event)
        }, null, 8, ["ttype"])]),
        _: 1
      }), _createVNode(_component_el_main, null, {
        default: _withCtx(() => [_createVNode(_component_viptabs), _createElementVNode("div", _hoisted_2, [_createVNode(_component_router_view)])]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  })]);
}